import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import VueRecaptcha from 'vue-recaptcha';
import keycloakService from '../../../../keycloakService'; 

export default {
	name: 'login',
	components: {
		VueRecaptcha,
		VueElementLoading
	},
	props: [],
	beforeRouteUpdate(to, from,next){
		this.$router.go()
	},
	data() {
		return {
			form: {
				robot: false
			},
			username: '',
			password: '',
			isLoading: false,
			loginTitle: "Fulfilling Happiness",
			clientListData: [],
			localwarehouseid: '',
			localclientid: '',
			eyeslash: true,
			eye: false,
			listWarehouseData: [],
		}
	},
	computed: {
		isAuthenticated() {
			return keycloakService.isAuthenticated();
		  },
	},
	mounted() {

	},
	methods: {
		async login() {
			localStorage.setItem('keycloakInitialized', true);

			let islogout = localStorage.getItem('islogout')
			islogout = islogout =='true' ? true : false
			if(islogout){
				localStorage.setItem("keyclockloginpage", false);
			}else{
				localStorage.setItem("keyclockloginpage", true);
			}
			window.location.reload();
			
			// await keycloakService.init();
			//  keycloakService.login();
		  },
	  
		  logout() {
			keycloakService.logout();
		  },
		Toggle() {
			var temp = document.getElementById("typepass");
			if (temp.type === "password") {
				temp.type = "text";
				this.eye = true;
				this.eyeslash = false;
			} else {
				temp.type = "password";
				this.eye = false;
				this.eyeslash = true;
			}
		},
		onVerify(response) {
			if (response == "") {
				this.$alert('Please verify that you are a Human.', "LogIn", "error");
			} else {
				this.$alert("Thank You", "LogIn", "success");
				this.form.robot = true;
			}
		},

		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (result) {
					// if (this.form.robot == false) {
					// 	this.$alert('Please verify that you are a Human.', "LogIn", "error");
					//
					// } else {
					// 	console.log('form is valid')
					// 	this.checklogin();
					// 	event.target.reset();;
					// }

					this.checklogin();
					event.target.reset();
				} else {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			})
		},
		checklogin() {
			if (this.username.trim() == '' || this.password.trim() == '') {
				return false;
			}
			this.isLoading = true;
			axios.post(apiUrl.api_url + 'auth', {
					'email': this.username,
					'password': this.password
				})
				.then((response) => {
					if (response.data.token) {
						var token = JSON.stringify(response.data.token);
					} else {
						this.$alertify.error("Invalid Username Or Password");
						this.isLoading = false;
						return false;
					}

					axios.post(apiUrl.api_url + 'getUserPermissions', {
						'email': this.username,
						'password': this.password
					}).then((response) => {
						this.isLoading = false;

						if (response.data == 'Inactive user') {
							this.$alertify.error("Inactive User")
							return false;
						}
						if (response.data == 'Invalid user') {
							this.$alertify.error("Invalid Username Or Password")
							return false;
						}
						if (response.data == 'Invalid/Unauthorised user') {
							this.$alertify.error("Unauthorised user")
							return false;
						}
						

						if (response.data[1].permissions.length > 0) {
							//debugger
							var permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[1].permissions), "Key");
							var userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[0].userdetail), "Key");
							window.localStorage.setItem('permissiondata', permissionEncrypt);
							window.localStorage.setItem('userdetail', userdetailEncrypt);
							window.localStorage.setItem('isLoggedIn', true);
							window.localStorage.setItem('userToken', token);
							window.localStorage.setItem('locale', response.data[0].userdetail.locale.trim());
							const slaConfigArray = response.data[3].slaconfig;

							// Convert the array to a JSON string
							const slaConfigJsonString = JSON.stringify( slaConfigArray );

							// Store the JSON string in localStorage
							window.localStorage.setItem('slaconfig', slaConfigJsonString);


							var innerpermissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data[2].innerpermission), "Key");
							window.localStorage.setItem('innerpermissiondata', innerpermissionEncrypt);

							var userdetailEncrypt = window.localStorage.getItem('userdetail')
							var permissionEncrypt = window.localStorage.getItem('permissiondata')
							var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
							var permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
							var plaintext = bytes.toString(CryptoJS.enc.Utf8);
							var permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);

							var userdetail = JSON.parse(plaintext);
							var permissiondata = JSON.parse(permissiondataplaintext);
							var uasertype = userdetail.utype;
							if (uasertype == 'warehouse_user') {
								this.localwarehouseid = userdetail.warehouseid;
								this.getClientList();
							}
							if (uasertype == 'system_user') {
								this.localwarehouseid = '';
								this.getClientList();
							}
							if (uasertype == 'client_user') {
								this.localclientid = userdetail.clientid
								this.getWarehouseList();
							}

							// if (uasertype === null || uasertype === '') {
							// 	this.$router.push('/dashboard');
							// 	this.$alertify.success("Logged In Successfully");
							// } else {
								this.$router.push('/dashboard');
								this.$alertify.success("Logged In Successfully");
							//}

						}
					}).catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				warehouseid: this.localwarehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.clientListData = result.data.data;
					var clientEncrypt = CryptoJS.AES.encrypt(JSON.stringify(this.clientListData), "Key");
					window.localStorage.setItem('clientList', clientEncrypt);
				}, error => {
					console.error(error);
				});
		},
		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				clientid: this.localclientid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseData = result.data.data;
					var warehouseEncrypt = CryptoJS.AES.encrypt(JSON.stringify(this.listWarehouseData), "Key");
					window.localStorage.setItem('warehouseList', warehouseEncrypt);
				}, error => {
					console.error(error)
				})
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js